export default function _pipe(f, g) {
  return function () {
    return g.call(this, f.apply(this, arguments));
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/internal/_pipe.js
// module id = ../node_modules/ramda/es/internal/_pipe.js
// module chunks = 5